


































































import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator'
import moment from 'moment'
import FileSaver from 'file-saver'
import RemuneracaoMedicaApi from '@/Apis/RemuneracaoMedica/Services/RemuneracaoMedicaApi'
import EventBus from '@/plugins/EventBus'
import { getSnackbarMessage, onlyNumber } from '@/utils/common'

@Component
export default class ModalCriarAgrupamento extends Vue {
  @Prop({ required: true, default: false }) visible: boolean
  @Prop({ default: () => [] }) fontesPagadoras: any[]

  onlyNumber = onlyNumber

  step = 1
  criando = false
  salvando = false

  formCriarValido = true
  formNumeroValido = true

  menuMes = false
  anoMesReferencia: string | null = null
  fontePagadoraId: string | null = null
  repassesQueSolicitamNF = false

  agrupamentoId = ''
  numeroChamado = ''
  somatorioTotalNotas = 0
  arquivoNotasFiscais = ''

  get anoMesReferenciaFormatado() {
    if (!this.anoMesReferencia) return ''
    return moment(this.anoMesReferencia, 'YYYY-MM').format('MM/YYYY')
  }

  @Watch('visible')
  onVisibleChange(novoValor: boolean) {
    if (!novoValor) return

    this.step = 1
    this.anoMesReferencia = null
    this.fontePagadoraId = null
    this.repassesQueSolicitamNF = false
    this.agrupamentoId = ''
    this.numeroChamado = ''
    this.somatorioTotalNotas = 0
    this.arquivoNotasFiscais = ''
  }

  async criar() {
    const form = this.$refs.formCriar as any
    if (form && !form.validate()) return

    this.criando = true
    try {
      const params = {
        anoMesReferencia: moment(this.anoMesReferencia, 'YYYY-MM').format('YYYY-MM-DD'),
        fontePagadoraId: this.fontePagadoraId,
        repassesQueSolicitamNF: this.repassesQueSolicitamNF,
      }

      const response: any = await RemuneracaoMedicaApi.criarAgrupamentoPrestadorRecebimento(params)
      if (!response.success) {
        EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Não foi possível criar o agrupamento.', icon: 'warning', color: '#C62828' })
        return
      }

      this.agrupamentoId = response.data.agrupamento.id
      this.somatorioTotalNotas = response.data.somatorioTotalNotas
      this.arquivoNotasFiscais = response.data.arquivoNotasFiscais
      this.step = 2
      // O agrupamento ja existe mesmo que o usuario feche sem informar o chamado: a lista precisa mostra-lo.
      this.criado()
    } finally {
      this.criando = false
    }
  }

  async salvarNumero() {
    const form = this.$refs.formNumero as any
    if (form && !form.validate()) return

    this.salvando = true
    try {
      const response: any = await RemuneracaoMedicaApi.atualizarAgrupamento({ id: this.agrupamentoId, numeroChamado: this.numeroChamado })
      if (!response.success) {
        EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Não foi possível salvar o número do chamado.', icon: 'warning', color: '#C62828' })
        return
      }

      EventBus.$emit('setSnackbar', { show: true, text: 'Agrupamento criado com sucesso.', icon: 'check', color: '#2E7D32' })
      this.chamadoSalvo()
      this.fechar(true)
    } finally {
      this.salvando = false
    }
  }

  baixarPdf() {
    if (!this.arquivoNotasFiscais) return

    try {
      const base64 = this.arquivoNotasFiscais.split(',')[1] || this.arquivoNotasFiscais
      const byteCharacters = atob(base64)
      const byteNumbers = new Array(byteCharacters.length)
      for (let i = 0; i < byteCharacters.length; i++) byteNumbers[i] = byteCharacters.charCodeAt(i)
      const blob = new Blob([new Uint8Array(byteNumbers)], { type: 'application/pdf' })

      const identificador = this.numeroChamado || this.agrupamentoId.substring(0, 8)
      FileSaver.saveAs(blob, `Agrupamento-${identificador}-${moment().format('DDMMYYYY')}.pdf`)
    } catch (erro) {
      console.error('Falha ao gerar o PDF do agrupamento', erro)
      EventBus.$emit('setSnackbar', getSnackbarMessage('Não foi possível gerar o PDF das notas fiscais.', 'error'))
    }
  }

  fechar(jaSalvo: boolean | Event = false) {
    if (jaSalvo !== true && this.step === 2) {
      const confirmaFechar = window.confirm('O agrupamento foi criado, mas o número do chamado ainda não foi salvo. Se fechar agora, você vai precisar informar o número depois pela tela de Agrupamentos. Deseja sair mesmo assim?')
      if (!confirmaFechar) return
    }

    this.close()
  }

  @Emit('close')
  close() { }

  @Emit('criado')
  criado() { }

  @Emit('chamado-salvo')
  chamadoSalvo() { }
}
